<template>
  <div :class="containerClass">
    <slot name="wrapper"></slot>
  </div>
</template>
<script>
//Swiper官网源文件支持CommomJS导入规范
let Swiper = require("./swiper.min.js");
import "./swiper.min.css";
export default {
  name: "boy91Swiper",
  props: {
    containerClass: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  },
  mounted() {
    new Swiper("." + this.containerClass, this.options);
  }
};
</script>



// WEBPACK FOOTER //
// src/packages/swiper/src/index.vue